//
// features-nav.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').directive('featuresNav', () => ({
        restrict: 'E',
        templateUrl: '/templates/partials/features-nav.html',
    }));
}))();
